import $ from 'jquery';

import { addToRegistry } from '../../../registry/js/actions/registryActions';

import { generate } from '../../../core/js/utils/componentUtils';
import { isQuickshop } from '../utils/quickshopUtils';
import { getRegistryFromIndex } from '../../../registry/js/utils/registryUtils';

import { mDom } from '../../../core/js/utils/renderUtils';

import template from 'product-registry-list.j2';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-registry-list',
        onStateChange: onStateChange,
        attachEvents: attachEvents,
        watch: ['registry', 'product.productRegistry'],
        template: template,
        name: 'productRegistryMultipleComponent',
        forFamilyProduct: false,
        listName: 'REGISTRY',
        renderType: mDom
    };

    return generate(config, store, overrides);
}

/**
 * Attach watcher to the store to trigger a render
 * @param {object} store The store
 */
export function onStateChange(store) {
    const product = this.getTargetedProduct(store.getState());
    this.render(store, this, {
        product: product,
        forFamilyProduct: this.forFamilyProduct,
    });
}

function formValidation(store, onValidFormAction, _this) {
    const formEl = $(_this.templateLocation).parents('.js-product-add-form');

    if (formEl.length > 0) {
        formEl.parsley().whenValidate()
            .then(() => {
                store.dispatch(onValidFormAction);
            });
    } else {
        store.dispatch(onValidFormAction);
    }
}

function attachEvents(store) {
    $(document).on(
        this.scopedEvent('touchend click'),
        this.scopedSelector('.js-add-to-registry'),
        (e) => {
            e.preventDefault();

            const index = $(e.target).attr('data-registry-index');
            const payload = {
                selectedRegistry: getRegistryFromIndex(store.getState(), index)
            };
            const meta = {
                component: this,
                event: e
            };
            const onValidFormAction = addToRegistry(payload, meta);

            formValidation(store, onValidFormAction, this);
        }
    );
}
